const shortVideo = {
  // 获取视频上传鉴权信息
  videoAuth: `/videoApi/v1/vod-upload/auth`,
  // 获取推荐封面
  recommendedPoster: `/videoApi/v1/recommendedPoster`,
  // 发布视频
  publish: `/videoApi/v1/publish`,
  // 保存/获取草稿
  draft: `/videoApi/v1/draft`
};

export default shortVideo;
